import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import { Can } from '../../../rbac/Can';
// Fontawesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAdd,
    faEdit
  } from "@fortawesome/free-solid-svg-icons";
// Helpers
import { formatDate, formatMoney } from "../../../utils/helpers";
// Components
import Select from "../../../components/form/Select";
import TableLoader from "../../../components/TableLoader";
import Pagination from "../../../components/Pagination";
// Store and Services
import { getBettorsList } from "../../../services/bettorService";
import { getAgentsList } from "../../../services/agentService";
import { fetchBets, refresh, setFilters, setPage } from "../../../redux/slices/betSlice";

function Bets() {
    const [bettors, setBettors] = useState([]);
    const [agents, setAgents] = useState([]);
    const { bets, pagination, loading, filters, page } = useSelector((state) => state.bet);
    const dispatch = useDispatch();

    useEffect(() => {

        getBettorsList().then((res) => {
            setBettors(res.data.data);
        });
    
        getAgentsList().then((res) => {
            setAgents(res.data.data);
        });
    
    }, []);

    useEffect(() => {
        dispatch(fetchBets());
    }, [dispatch, filters, page]);

    const handleSearch = (values) => {
        dispatch(setFilters(values));
    };
    
    return (
        <>
        <div className="flex justify-between items-end">
            <h1 className="text-lg font-bold">Bets</h1>
            <Can I="create" a="bets">
                <Link to="/admin/bets/add" className="btn-primary">
                    <FontAwesomeIcon icon={faAdd} className="mr-2"/>
                    Add Bet
                </Link>
            </Can>   
        </div>

        <hr className="border-black border-2 mt-2" />

        <Formik
            initialValues={filters}
            onSubmit={handleSearch}
        >
            {({ resetForm, submitForm }) => (
                <Form className="flex gap-4 my-4">
                    <Field
                        type="date"
                        name="bet_date"
                        id="bet_date"
                        className="form-control"
                        placeholder="Select bet date"
                    />
                    <Select 
                        name="bettor_id" 
                        options={bettors}
                        optionValue="id"
                        optionLabel="name"
                        placeholder="Select bettor"
                    />
                    <Select 
                        name="agent_id" 
                        options={agents}
                        optionValue="id"
                        optionLabel="name"
                        placeholder="Select agents"
                    />
                    <button type="submit" className="btn-primary">
                        Search
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            resetForm();
                            submitForm();
                        }}
                        className="btn-dark"
                    >
                        Reset
                    </button>
                </Form>
            )}
        </Formik>
        <hr className="border-black border-2 mt-2" />
        {loading ? (
            <TableLoader />    
        ) : (
            <>
            <table className="table-auto w-full border-collapse mt-8 text-sm">
                <thead className="table-header-group">
                    <tr>
                        <th>ID</th>
                        <th>Date</th>
                        <th>Player Name</th>
                        <th>Agent</th>
                        <th>League</th>
                        <th>Play Details</th>
                        <th>Odds</th>
                        <th>Play Type</th>
                        <th>W/L/P</th>
                        <th>Amount</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {bets?.map((item, index) => (
                        <tr
                            key={index}
                            className="rounded-md text-center border border-b-1 border-t-0 border-r-0 border-l-0 py-4 cursor-pointer hover:bg-gray-200"
                        >
                            <td className="overflow-hidden py-4">{item?.id}</td>
                            <td className="overflow-hidden py-4">{formatDate(item?.bet_date)}</td>
                            <td className="overflow-hidden py-4">{item?.bettor?.name}</td>
                            <td className="overflow-hidden py-4">{item?.agent?.name}</td>
                            <td className="overflow-hidden py-4">{item?.league}</td>
                            <td className="overflow-hidden py-4">{item?.play_details}</td>
                            <td className="overflow-hidden py-4">{item?.odds}</td>
                            <td className="overflow-hidden py-4">{item?.play_type}</td>
                            <td className="overflow-hidden py-4">{item?.outcome}</td>
                            <td className="overflow-hidden py-4">{formatMoney(item?.amount)}</td>
                            <td className="overflow-hidden py-4">
                            <Can I="update" a="bets">
                                <Link to={`/admin/bets/edit/${item?.id}`} className="btn-primary">
                                  <FontAwesomeIcon icon={faEdit} className="mr-2"/>
                                  Edit
                                </Link>
                            </Can>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Pagination pagination={pagination} onPageChange={(page) => dispatch(setPage(page))} />
            </>
        )}
        </>
    );
}

export default Bets;
